import { mutationTree, actionTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'
import { waitUntilResolve, waitMinimum } from '~/lib/utils/utils'
import { sortBy } from '~/lib/utils/sorting'

interface EligibleSorted {
  scholarshipId: number;
  weight: number;
}

export const state = () => ({
  eligibleSortedScholarships: null as null | EligibleSorted
})

export const mutations = mutationTree(state, { setState })

export const actions = actionTree(
  { state, mutations },
  {
    async setEligibleSortedScholarships({ state, commit, dispatch, rootGetters }) {
      if (state.eligibleSortedScholarships) { return Promise.resolve(state.eligibleSortedScholarships) }

      const { accountId } = await dispatch('account/getResourceValue', {
        resourceName: 'account',
        resourceFields: ['accountId']
      }, { root: true })

      let promise = this.$api.scholarship.eligibleSorted({ id: accountId })
      promise = waitUntilResolve(promise, 60000)
      promise = waitMinimum(promise, 3000)

      return promise
        .then((res: any) => {
          const list = sortBy<EligibleSorted>(res.rawRes.data, 'desc', 'weight')
          commit('setState', { stateName: 'eligibleSortedScholarships', data: list })
          return list
        })
    }
  }
)
